// Mock data for Trade With Peace website

export const mockData = {
  hero: {
    headline: "Trade Smart. Stay Calm. Grow Consistently.",
    subheadline: "I'm Abhay Yadav, helping traders master market psychology, risk management, and practical trading strategies.",
    primaryCTA: "Watch My Market Analysis",
    secondaryCTA: "Join Free Community",
    trustBadges: [
      "Beginner Friendly",
      "Risk Management Focus",
      "Real Market Insights"
    ],
    profileImage: "https://customer-assets.emergentagent.com/job_calm-trader-hub/artifacts/ta00nlng_IMG_0048.jpeg"
  },

  marketTicker: [
    { symbol: "NIFTY 50", price: "24,835.50", change: "+1.25%", trend: "up" },
    { symbol: "SENSEX", price: "82,248.45", change: "+0.98%", trend: "up" },
    { symbol: "BANK NIFTY", price: "52,145.30", change: "-0.45%", trend: "down" },
    { symbol: "RELIANCE", price: "2,845.60", change: "+2.10%", trend: "up" },
    { symbol: "TCS", price: "3,567.80", change: "+1.50%", trend: "up" },
    { symbol: "INFY", price: "1,823.25", change: "-0.30%", trend: "down" }
  ],

  about: {
    title: "Why Trade With Peace?",
    content: "Most traders lose money because of emotions and lack of discipline. My mission is to simplify trading, focus on risk control, and help you grow steadily without stress. I believe consistency and psychology matter more than hype.",
    image: "https://images.pexels.com/photos/5833752/pexels-photo-5833752.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    stats: [
      { value: "500+", label: "Community Members" },
      { value: "15+", label: "Success Stories" },
      { value: "3+", label: "Years Experience" }
    ]
  },

  services: [
    {
      id: 1,
      title: "Daily Market Analysis",
      description: "Practical and easy-to-understand breakdown of market moves, helping you make informed decisions with clarity.",
      image: "https://images.pexels.com/photos/11798250/pexels-photo-11798250.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
    },
    {
      id: 2,
      title: "Trading Strategy Simplified",
      description: "Clear entry, exit, and risk rules designed to help you trade with confidence and remove guesswork.",
      image: "https://images.pexels.com/photos/33000099/pexels-photo-33000099.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
    },
    {
      id: 3,
      title: "Risk Management & Psychology",
      description: "Master emotional control and capital protection. Learn the mindset that separates successful traders from the rest.",
      image: "https://images.pexels.com/photos/24709180/pexels-photo-24709180.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
    }
  ],

  testimonials: [
    {
      id: 1,
      name: "Rajesh Kumar",
      role: "Day Trader",
      content: "Abhay's focus on psychology changed my trading completely. No more emotional decisions!",
      rating: 5
    },
    {
      id: 2,
      name: "Priya Sharma",
      role: "Beginner Trader",
      content: "Finally, someone who explains trading in simple terms. Best decision to join this community.",
      rating: 5
    },
    {
      id: 3,
      name: "Amit Patel",
      role: "Part-time Trader",
      content: "Risk management lessons alone saved me thousands. Highly recommended!",
      rating: 5
    },
    {
      id: 4,
      name: "Sneha Gupta",
      role: "Swing Trader",
      content: "The daily analysis is spot on. Love the calm and disciplined approach.",
      rating: 5
    }
  ],

  blogs: [
    {
      id: 1,
      title: "Market Analysis: Understanding Today's Trends",
      excerpt: "Learn how to read market signals and make informed decisions based on technical and fundamental analysis.",
      image: "https://images.pexels.com/photos/7947635/pexels-photo-7947635.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      date: "Dec 20, 2025",
      category: "Market Analysis"
    },
    {
      id: 2,
      title: "Beginner Trading Guide: Start Your Journey Right",
      excerpt: "Everything you need to know to start trading safely, from account setup to your first trade.",
      image: "https://images.unsplash.com/photo-1599840448769-f4ac7aac8d8b?crop=entropy&cs=srgb&fm=jpg&q=85",
      date: "Dec 18, 2025",
      category: "Education"
    },
    {
      id: 3,
      title: "Trading Psychology: Master Your Mind",
      excerpt: "Discover the mental frameworks that help professional traders stay calm and profitable in any market.",
      image: "https://images.unsplash.com/photo-1546538915-a9e2c8d0a0b2?crop=entropy&cs=srgb&fm=jpg&q=85",
      date: "Dec 15, 2025",
      category: "Psychology"
    }
  ],

  faqs: [
    {
      id: 1,
      question: "Is this suitable for beginners?",
      answer: "Absolutely! I focus on breaking down complex trading concepts into simple, actionable steps. Whether you're brand new or have some experience, my content is designed to help you build a strong foundation."
    },
    {
      id: 2,
      question: "Do you provide trading calls?",
      answer: "No, I don't provide direct buy/sell calls. My approach is educational - I teach you how to analyze the market, manage risk, and make your own informed decisions. This empowers you to become an independent trader."
    },
    {
      id: 3,
      question: "What makes your approach different?",
      answer: "Unlike typical trading influencers who focus on quick profits, I emphasize psychology, risk management, and consistency. My goal is to help you trade with peace of mind, not stress and FOMO."
    },
    {
      id: 4,
      question: "How can I join the community?",
      answer: "You can join our free Telegram community where I share market insights, educational content, and interact with fellow traders. Just click the 'Join Free Community' button or the Telegram link in the community section."
    }
  ],

  community: {
    subscriberCount: "500+",
    telegramLink: "https://t.me/trade_with_PEACE1",
    instagramLink: "https://www.instagram.com/trade_with_peace2025?igsh=aGRiOXJsYmMwdDhm&utm_source=qr",
    instagramQR: "https://customer-assets.emergentagent.com/job_calm-trader-hub/artifacts/x8b50qly_trade_with_peace2025_qr.png",
    youtubeLink: "https://youtube.com/@trade_with_peace?si=ABXT11zjnCLDSpCs"
  },

  footer: {
    disclaimer: "Educational Purpose Only. Trading involves risk. Please consult with a financial advisor before making investment decisions.",
    email: "tradewithpeace3@gmail.com",
    telegramLink: "https://t.me/trade_with_PEACE1",
    instagramLink: "https://www.instagram.com/trade_with_peace2025?igsh=aGRiOXJsYmMwdDhm&utm_source=qr",
    youtubeLink: "https://youtube.com/@trade_with_peace?si=ABXT11zjnCLDSpCs"
  }
};
